import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const BrandAdd = () => {
 const navigate = useNavigate();
  const initialFormState = {
    brand_name: "",
    manuf_name: "",
    manuf_state:"",
    status: ""
  };

  const [brandUser, setbrandUser] = useState(initialFormState);
  const [brandimage, setbrandImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setbrandUser({ ...brandUser, [name]: value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setbrandImage(file);
    if (file) {
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  const submitForm = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("brand_name", brandUser.brand_name.trim());
    formData.append("manuf_name", brandUser.manuf_name.trim());
    formData.append("manuf_state", brandUser.manuf_state.trim());
    formData.append("status", brandUser.status.trim());
      formData.append("brand_logo", brandimage);

    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_brand",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );

      if (response.data.status === true || response.data.status === "true") {
        toast.success(response.data.message || "brand added successfully!");
        setbrandUser(initialFormState);
        setbrandImage(null);
        setPreviewImage(null);
        navigate("/brand-list");
      } else {
        toast.error(response.data.error || "Failed to add brand");
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Something went wrong!");
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Brand Add</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript: void(0);">Brand</a>
                </li>
                <li className="breadcrumb-item active">Brand Add</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Form */}
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Add Brand</h4>
              </div>
                <form onSubmit={submitForm}>
              <div className="card-body">
                  <div className="row">
                      <div className="col-lg-6 mb-3">
                      <label htmlFor="brand-logo" className="form-label text-dark">
                        Brand Logo
                      </label>
                      <input
                        type="file"
                        id="brand-logo"
                        className="form-control"
                        accept="image/*"
                        onChange={handleImageChange}
                      />
                      {previewImage && (
                        <img
                          src={previewImage}
                          alt="Logo Preview"
                          className="mt-2"
                          style={{ width: "100px", height: "auto" }}
                        />
                      )}
                    </div>
                    <div className="col-lg-6 mb-3">
                      <label htmlFor="brand_name" className="form-label text-dark">
                        Brand Name
                      </label>
                      <input
                        type="text"
                        id="brand_name"
                        name="brand_name"
                        value={brandUser.brand_name}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Enter Brand Name"
                      />
                    </div>

                    <div className="col-lg-6 mb-3">
                      <label htmlFor="manuf_name" className="form-label text-dark">
                        Manufacturer Name
                      </label>
                      <input
                        type="text"
                        id="manuf_name"
                        name='manuf_name'
                        value={brandUser.manuf_name}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Enter Manufacturer Name"
                      />
                    </div>

                    <div className="col-lg-6 mb-3">
                      <label htmlFor="manuf_state" className="form-label text-dark">
                        Manufacturer State
                      </label>
                      <input
                        type="text"
                        id="manuf_state"
                        name='manuf_state'
                        value={brandUser.manuf_state}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Enter Manufacturer State"
                      />
                    </div>

                    <div className="col-lg-6 mb-3">
                      <label htmlFor="status" className="form-label text-dark">
                        Status
                      </label>
                      <select className="form-control"
                       id="status"
                       name='status'
                       value={brandUser.status}
                       onChange={handleInput}
                       >
                        <option value="">-- Select Status --</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                      </select>
                    </div>
                  </div>
              
              </div>
              <div className="card-footer border-top">
                <button type='submit' className="btn btn-primary">
                  Add
                </button>
              </div>
                </form>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />{" "}
              <a href="" className="fw-bold footer-text" target="_blank">
                Techzaa
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default BrandAdd;
